<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="col-md-2 pt-0">
                  <v-combobox v-model="client_selected" autocomplete="off" item-text="name" item-value="id" :items="clients" label="Cliente" class="pt-0 mt-0" clearable></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-autocomplete
                    v-model="exclude_clients_selected"
                    item-text="name"
                    item-value="id"
                    :items="clients"
                    label="Excluir clientes"
                    class="pt-0 mt-0"
                    multiple
                    small-chips
                    deletable-chips
                    clearable
                  ></v-autocomplete>
                </div>
                <div class="col-md-2 pt-0">
                  <v-text-field v-model="tea" type="number" min="0" step="0.01" label="TEA" suffix="%" :hint="'TEM ' + formatUtils.formatNumber(tem) + '%'" persistent-hint class="pt-0 mt-0"></v-text-field>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end; align-items: center">
                  <v-btn color="info" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access && sintesis" class="mt-2">
        <v-card-text>
          <div class="row">
            <div class="col-md-2">
              <div class="caption">Total cobrado</div>
              <div class="title">{{ formatUtils.formatPrice(sintesis.total) }}</div>
            </div>
            <div class="col-md-2">
              <div class="caption">Numerales</div>
              <div class="title">{{ formatUtils.formatNumber(sintesis.numerales) }}</div>
            </div>
            <div class="col-md-2">
              <div class="caption">Promedio ponderado</div>
              <div class="title">{{ Math.round(sintesis.promedio) }} días</div>
            </div>
            <div class="col-md-2">
              <div class="caption">Costo financiero General</div>
              <div class="title red--text">{{ formatUtils.formatPrice(sintesis.general) }}</div>
            </div>
            <div class="col-md-2">
              <div class="caption">Costo financiero Individual</div>
              <div class="title red--text">{{ formatUtils.formatPrice(sintesis.individual) }}</div>
            </div>
            <div class="col-md-2">
              <div class="caption">Diferencia por ponderación</div>
              <div class="title">{{ formatUtils.formatPrice(sintesis.diferencia) }} ({{ formatUtils.formatNumber(sintesis.diferencia_per) }}%)</div>
            </div>
          </div>
          <div class="caption">
            TEA {{ formatUtils.formatNumber(result_tea) }}% · TEM {{ formatUtils.formatNumber(result_tem) }}%
            <span v-if="sin_comprobantes.cantidad > 0">
              · {{ sin_comprobantes.cantidad }} recibo/s sin comprobantes imputados no incluidos ({{ formatUtils.formatPrice(sin_comprobantes.monto) }})
            </span>
          </div>
        </v-card-text>
      </v-card>

      <v-card v-if="list_access" class="mt-2">
        <v-card-title>
          <v-btn color="blue-grey" class="mt-3" small dark :loading="dialog_export" @click="exportToExcel">
            Exportar
            <font-awesome-icon class="ml-2" icon="download"
          /></v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          item-key="id"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            itemsPerPage: 50,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [15, 50, 100, -1],
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.nro_recibo }}</td>
              <td>{{ formatUtils.formatDateString(item.fecha) }}</td>
              <td>{{ item.client_name }}</td>
              <td>{{ item.cuit }}</td>
              <td class="text-right">{{ formatUtils.formatPrice(item.total) }}</td>
              <td>{{ formatUtils.formatDateString(item.fecha_factura) }}</td>
              <td>{{ formatUtils.formatDateString(item.fecha_pago) }}</td>
              <td class="text-right">{{ Math.round(item.plazo) }} días</td>
              <td>{{ item.observacion }}</td>
              <td class="text-right">{{ formatUtils.formatPrice(item.intereses) }}</td>
              <td class="text-right">{{ formatUtils.formatNumber(item.numerales) }}</td>
              <td class="text-center">
                <font-awesome-icon class="cursor" :icon="expandedRows.includes(item.id) ? 'chevron-up' : 'chevron-down'" @click="toggleExpand(item.id)" />
              </td>
            </tr>
            <tr v-if="expandedRows.includes(item.id)">
              <td colspan="12" class="grey lighten-4">
                <div class="row">
                  <div class="col-md-6">
                    <v-simple-table dense class="grey lighten-4">
                      <thead>
                        <tr>
                          <th>Comprobante</th>
                          <th>Fecha</th>
                          <th>Moneda</th>
                          <th class="text-right">Imputado (ARS)</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(f, i) in item.facturas" :key="'f' + i">
                          <td>{{ f.comprobante }}</td>
                          <td>{{ formatUtils.formatDateString(f.fecha) }}</td>
                          <td>{{ f.moneda }}</td>
                          <td class="text-right">{{ formatUtils.formatPrice(f.importe) }}</td>
                          <td>{{ f.parcial ? "Parcial" : "" }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                  <div class="col-md-6">
                    <v-simple-table dense class="grey lighten-4">
                      <thead>
                        <tr>
                          <th>Medio de cobro / Retención</th>
                          <th>N°</th>
                          <th>Fecha</th>
                          <th class="text-right">Importe</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(v, i) in item.valores" :key="'v' + i">
                          <td>{{ v.tipo }}</td>
                          <td>{{ v.numero }}</td>
                          <td>{{ formatUtils.formatDateString(v.fecha) }}</td>
                          <td class="text-right">{{ formatUtils.formatPrice(v.importe) }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Constant from "@/constants/sections";
import { clientsService } from "@/libs/ws/clientsService";
import { reportService } from "@/libs/ws/reportService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: reportService,
      page_title: "Costo Financiero por Plazo de Cobranza",
      headers: [
        { text: "Número", align: "left", sortable: true, value: "nro_recibo" },
        { text: "Fecha", align: "left", sortable: true, value: "fecha" },
        { text: "Cliente", align: "left", sortable: true, value: "client_name" },
        { text: "CUIT", align: "left", sortable: true, value: "cuit" },
        { text: "Total", align: "right", sortable: true, value: "total" },
        { text: "Factura/s", align: "left", sortable: true, value: "fecha_factura" },
        { text: "Pago", align: "left", sortable: true, value: "fecha_pago" },
        { text: "Plazo", align: "right", sortable: true, value: "plazo" },
        { text: "Observación", align: "left", sortable: true, value: "observacion" },
        { text: "Intereses", align: "right", sortable: true, value: "intereses" },
        { text: "Numerales", align: "right", sortable: true, value: "numerales" },
        { text: "", value: "", sortable: false },
      ],
      list: [],
      clients: [],
      sintesis: null,
      sin_comprobantes: { cantidad: 0, monto: 0 },
      result_tea: 0,
      result_tem: 0,
      expandedRows: [],
      desde_selected_open: false,
      hasta_selected_open: false,
      client_selected: null,
      exclude_clients_selected: [],
      tea: 32.53,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
    };
  },
  computed: {
    tem() {
      const tea = parseFloat(this.tea) || 0;
      return (Math.pow(1 + tea / 100, 1 / 12) - 1) * 100;
    },
  },
  mounted() {
    this.loadComboData();
    this.loadList(this.service, this.getFilterParams());
  },
  methods: {
    loadList(service, param = null) {
      this.loading = true;
      if (param == null) {
        param = this.getFilterParams();
      }
      service
        .getReportsPonderacionCharge(param)
        .then((response) => {
          this.loading = false;
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.list = response.result.rows;
          this.sintesis = response.result.sintesis;
          this.sin_comprobantes = response.result.sin_comprobantes;
          this.result_tea = response.result.tea;
          this.result_tem = response.result.tem;
          this.expandedRows = [];
        })
        .catch((e) => {
          console.log("service.getReportsPonderacionCharge error");
          console.log(e);
          this.loading = false;
        });
    },
    getFilterParams() {
      return {
        from: this.desde_selected,
        to: this.hasta_selected,
        client: this.client_selected != null ? this.client_selected.id : null,
        exclude_clients: this.exclude_clients_selected,
        tea: this.tea !== "" ? this.tea : 0,
      };
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    toggleExpand(id) {
      const index = this.expandedRows.indexOf(id);
      if (index === -1) this.expandedRows.push(id);
      else this.expandedRows.splice(index, 1);
    },
    loadComboData() {
      clientsService.filterMinify().then((response) => {
        this.clients = response.result;
      });
    },
    exportToExcel() {
      var param = this.getFilterParams();
      param["export"] = true;
      let fileName = "Costo-Financiero-Plazo-Cobranza.xlsx";
      this.exportExcel(Constant.SECTION_REPORTS + "/ponderacion-charges", param, fileName);
    },
  },
};
</script>
